export default [
  {
    icon: 'HardDriveIcon',
    rule: 'drive.menu',
    title: 'Drive',
    route: 'drive-index'
  },
  {
    title: 'Segurança',
    icon: 'ShieldIcon',
    rule: 'acl.menu',
    children: [
      {
        route: 'users',
        title: 'Users',
        icon: 'UserIcon',
        rule: 'users.menu'
      },
      {
        route: 'roles',
        title: 'Roles',
        icon: 'TargetIcon',
        rule: 'roles.menu'
      },
      {
        route: 'functionality-index',
        title: 'Functionalities',
        icon: 'GridIcon',
        rule: 'functionalities.menu'
      },
      {
        route: 'user-access-logs',
        title: 'Logs de acesso',
        icon: 'ActivityIcon',
        rule: 'user_access_logs.menu'
      }
    ]
  },
  {
    title: 'People',
    icon: 'UsersIcon',
    rule: 'people.menu',
    children: [
      {
        title: 'NaturalEntity',
        route: 'people-natural-entities'
      },
      {
        title: 'LegalEntity',
        route: 'people-legal-entities'
      }
    ]
  },
  {
    route: 'people-employees',
    title: 'Employees',
    icon: 'UserCheckIcon',
    rule: 'employees.menu'
  },
  {
    title: 'Contatos',
    icon: 'MailIcon',
    rule: 'contacts.menu',
    children: [
      {
        icon: 'UserPlusIcon',
        title: 'Contato',
        route: 'contact-index'
      },
      {
        icon: 'BookOpenIcon',
        title: 'Lista de Contatos',
        route: 'contact-list-index'
      }
    ]
  },
  {
    route: 'schedules',
    title: 'schedulesTitle',
    icon: 'CalendarIcon',
    i18n: 'schedulesTitle',
    rule: 'schedules.menu'
  },
  {
    title: 'Base de Conhecimento',
    icon: 'BookOpenIcon',
    rule: 'knowledge_items.menu',
    children: [
      {
        icon: 'FilePlusIcon',
        title: 'Cadastro',
        route: 'knowledge-item-index'
      },
      {
        icon: 'BookOpenIcon',
        title: 'Consulta',
        route: 'knowledge-item-consult'
      }
    ]
  },
  {
    title: 'Documentação',
    icon: 'BookIcon',
    rule: 'documents.menu',
    children: [
      {
        icon: 'FilePlusIcon',
        title: 'Cadastro',
        route: 'document-index'
      },
      {
        icon: 'BookOpenIcon',
        title: 'Consulta',
        route: 'document-consult-index'
      }
    ]
  },
  {
    title: 'Informativos',
    icon: 'AtSignIcon',
    rule: 'newsletters.menu',
    children: [
      {
        icon: 'FilePlusIcon',
        title: 'Gestão',
        rule: 'newsletters.grid',
        route: 'newsletter-index'
      },
      {
        icon: 'InfoIcon',
        title: 'Moderação',
        rule: 'newsletters_moderator.grid',
        route: 'newsletter-moderator-index'
      },
      {
        icon: 'CalendarIcon',
        title: 'Workflow',
        rule: 'newsletter_workflows.grid',
        route: 'newsletter-workflow-index'
      },
      {
        icon: 'GridIcon',
        title: 'Grupo',
        rule: 'group_news.grid',
        route: 'group-news-index'
      },
      {
        icon: 'ListIcon',
        title: 'Subgrupo',
        rule: 'subgroup_news.grid',
        route: 'subgroup-news-index'
      }
    ]
  },
  {
    route: 'privacy-form',
    title: 'privacyFormTitle',
    icon: 'PocketIcon',
    i18n: 'privacyFormTitle',
    rule: 'privacy_form.menu'
  },
  {
    route: 'incident-form',
    title: 'incidentFormTitle',
    icon: 'AlertTriangleIcon',
    i18n: 'incidentFormTitle',
    rule: 'incident_form.menu'
  },
  {
    route: 'due-diligence-form-index',
    title: 'dueDiligenceFormTitle',
    icon: 'CheckIcon',
    i18n: 'dueDiligenceFormTitle',
    rule: 'due_diligence_form.menu'
  },
  {
    route: 'intimidation_form_index',
    title: 'systematic_intimidation.title',
    icon: 'EyeIcon',
    i18n: 'systematic_intimidation.title',
    rule: 'intimidation_form_handling.menu'
  },
  {
    title: 'reporting_channel.menu.title',
    icon: 'MehIcon',
    i18n: 'reporting_channel.menu.title',
    rule: 'reporting_channel_handling.menu',
    children: [
      {
        route: 'reporting_channel_dashboard_index',
        title: 'reporting_channel.menu.dashboard',
        icon: 'BarChartIcon',
        i18n: 'reporting_channel.menu.dashboard',
        rule: 'reporting_channel_handling.dashboard.menu'
      },
      {
        route: 'reporting_channel_screening_index',
        title: 'reporting_channel.menu.screening',
        icon: 'FilterIcon',
        i18n: 'reporting_channel.menu.screening',
        rule: 'reporting_channel_handling.screening.menu'
      },
      {
        route: 'reporting_channel_index',
        title: 'reporting_channel.menu.handling',
        icon: 'FileTextIcon',
        i18n: 'reporting_channel.menu.handling',
        rule: 'reporting_channel_handling.menu'
      },
      {
        route: 'handling_status_configuration_index',
        title: 'reporting_channel.menu.configuration',
        icon: 'SettingsIcon',
        i18n: 'reporting_channel.menu.configuration',
        rule: 'reporting_channel_handling.configuration.menu'
      },
      {
        title: 'reporting_channel.menu.reports.title',
        icon: 'FileTextIcon',
        i18n: 'reporting_channel.menu.reports.title',
        rule: 'reporting_channel_handling.reports.menu',
        children: [
          {
            route: 'reporting_channel_reports_response_time_index',
            title: 'reporting_channel.menu.reports.response_time',
            icon: 'ClockIcon',
            i18n: 'reporting_channel.menu.reports.response_time',
            rule: 'reporting_channel_handling.reports.response_time.menu'
          },
          {
            route: 'reporting_channel_reports_type_reporting_index',
            title: 'reporting_channel.menu.reports.type_reporting',
            icon: 'FileTextIcon',
            i18n: 'reporting_channel.menu.reports.type_reporting',
            rule: 'reporting_channel_handling.reports.type_reporting.menu'
          },
          {
            route: 'reporting_channel_reports_identification_index',
            title: 'reporting_channel.menu.reports.identification',
            icon: 'UserCheckIcon',
            i18n: 'reporting_channel.menu.reports.identification',
            rule: 'reporting_channel_handling.reports.identification.menu'
          },
          {
            route: 'reporting_channel_reports_severity_index',
            title: 'reporting_channel.menu.reports.severity',
            icon: 'TrendingUpIcon',
            i18n: 'reporting_channel.menu.reports.severity',
            rule: 'reporting_channel_handling.reports.severity.menu'
          }
        ]
      }
    ]
  },
  {
    title: 'Portal CEBAS',
    icon: 'UserPlusIcon',
    rule: 'portal_cebas.menu',
    children: [
      {
        icon: 'CheckCircleIcon',
        title: 'Credenciamento',
        rule: 'portal_cebas.credentialing.menu',
        route: 'portal-cebas-credentialing-index',
        children: [
          {
            icon: 'FilePlusIcon',
            title: 'Configuração',
            rule: 'portal_cebas.credentialing.config.menu',
            route: 'portal-cebas-credentialing-config-index'
          },
          {
            icon: 'UserCheckIcon',
            title: 'Tratamento',
            rule: 'portal_cebas.credentialing.handling.menu',
            route: 'portal-cebas-credentialing-handling-index'
          }
        ]
      },
      {
        icon: 'UsersIcon',
        title: 'Vagas',
        rule: 'portal_cebas.vacancies.menu',
        route: 'portal-cebas-vacancies-index',
        children: [
          {
            icon: 'FilePlusIcon',
            title: 'Configuração',
            rule: 'portal_cebas.vacancies.config.menu',
            route: 'portal-cebas-vacancies-config-index'
          },
          {
            icon: 'UserCheckIcon',
            title: 'Tratamento',
            rule: 'portal_cebas.vacancies.handling.menu',
            route: 'portal-cebas-vacancies-handling-index'
          }
        ]
      }
    ]
  }
]
